import httpClient from '../lib/httpClient';
import { ENDPOINTS } from './api/endpoints';
/**

 * Send Keycloak access token and refresh token to backend API
 * This allows the backend to set HTTP-only cookies for secure authentication
 * @param {string} accessToken - Keycloak access token
 * @param {string} refreshToken - Keycloak refresh token
 * @param {number} accessTokenExpiresIn - Access token expiration time in seconds
 * @param {number} refreshTokenExpiresIn - Refresh token expiration time in seconds
 * @returns {Promise<any>}
 */

export async function sendKeycloakTokens(accessToken, refreshToken, accessTokenExpiresIn, refreshTokenExpiresIn) {
  const payload = {
    accessToken,
    refreshToken,
    accessTokenExpiresIn,
    refreshTokenExpiresIn,
  };

  const response = await httpClient.post(ENDPOINTS.AUTH.KEYCLOAK_TOKEN, payload, {
    withCredentials: true,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return response.data;
}

/**
 * Clear authentication cookies from backend
 * @returns {Promise<void>}
 */
export async function clearAuthCookies() {
  const response = await httpClient.delete(ENDPOINTS.AUTH.KEYCLOAK_TOKEN);
  return response.data;
}

